export default __webpack_public_path__ + "static/media/icon6.53d68503.svg";